import { useEffect, useRef } from 'react';

const usePreloadImages = (urls) => {
  const prevRef = useRef('');

  useEffect(() => {
    const key = urls.filter(Boolean).join(',');
    if (key === prevRef.current) return;
    prevRef.current = key;
    urls.forEach((src) => {
      if (src) new Image().src = src;
    });
  });
};

export default usePreloadImages;
